/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { CSSProperties } from 'react';
import { Drawer as DrawerMui } from '@mui/material';
import { BaseDrawer, Container, Content } from './styles/StyledDrawer';

type Anchor = 'top' | 'left' | 'bottom' | 'right';

// import { IconBack } from 'presentation/base/icons';

interface ownProps {
  children: React.ReactNode;
  isOpen: boolean;
  anchor: Anchor;
  style?: CSSProperties;
  handleClose: () => void;
}

type Props = ownProps;

const Drawer: React.FC<Props> = ({
  children,
  anchor,
  isOpen,
  style,
  handleClose,
}): JSX.Element => {
  const closeDrawer = () => (event: React.KeyboardEvent | React.MouseEvent) => {
    if (
      event.type === 'keydown' &&
      ((event as React.KeyboardEvent).key === 'Tab' ||
        (event as React.KeyboardEvent).key === 'Shift')
    ) {
      return;
    }

    handleClose();
  };

  return (
    <Container>
      <Content>
        <DrawerMui anchor={anchor} open={isOpen} onClose={closeDrawer()}>
          <BaseDrawer style={style}>{children}</BaseDrawer>
        </DrawerMui>
      </Content>
    </Container>
  );
};

export default Drawer;
